import createXhr from './utils/createXhr';

let timestampIndex = 0;

/**
 * 创建一个ajax请求，该请求返回一个promise对象
 * @param {String} url 请求地址
 * @param {Object} options 扩展参数，参数内容如下
 *   @param {Object} body 需要传给服务器的参数，放置在body中传递
 *   @param {Object} query 需要传给服务器的参数，放置在url后面传递
 *   注意：参数会进行encodeURIComponent编码
 *   @param {String} type ajax 请求类别 默认为 get，可选值为 get | post
 *   @param {Number || Boolean} cache 只能是数字类型，如果是false，则不会拼接该参数
 *   @param {Number} timeout 超时时间，默认为60000毫秒
 *   @param {Boolean} async 请求是否异步，默认为true，异步请求，一般不建议改动该值
 *   @param {Boolean} corsCookie 如果请求跨域，需要cookie，需要设置为true，默认为false，如果设置为true，服务端跨域头不能使用通配符*
 */
export default function(
    url,
    {
        query = {},
        body = {},
        type = 'get',
        cache = `${new Date().valueOf()}${timestampIndex++}`,
        timeout = 60000,
        async = true,
        corsCookie = false,
    } = {},
) {
    return Promise.race([
        new Promise((resolve, reject) => {
            const xhr = createXhr();

            // 对参数进行处理
            const params = [];

            if (typeof query === 'object') {
                for (const key of Object.keys(query)) {
                    params.push(`${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`);
                }
            } else {
                reject({
                    code: 'queryError',
                    tips: '参数类型错误',
                    msg: { msg: '参数类型错误', content: query },
                    status: xhr.status,
                });

                return;
            }

            if (typeof body !== 'object') {
                reject({
                    code: 'bodyError',
                    tips: '参数类型错误',
                    msg: { msg: '参数类型错误', content: body },
                    status: xhr.status,
                });

                return;
            }

            if (cache) {
                params.push(`_=${cache}`);
            }

            if (url.includes('?')) {
                url = `${url}&${params.join('&')}`;
            } else {
                url = `${url}?${params.join('&')}`;
            }

            if (corsCookie) {
                xhr.withCredentials = true;
            }

            xhr.open(type, url, async);

            if (type.toLocaleLowerCase() === 'post') {
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            }
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
                        try {
                            const result = new Function(`return ${xhr.responseText || '{}'}`)();

                            if (typeof result === 'object') {
                                resolve(result);
                            } else {
                                reject({
                                    code: 'typeError',
                                    tips: '服务器忙，请稍后再试',
                                    msg: { msg: '返回结果不是对象', content: xhr.responseText },
                                    status: xhr.status,
                                });
                            }
                        } catch (e) {
                            reject({
                                code: 'parseError',
                                tips: '服务器忙，请稍后再试',
                                msg: { msg: '返回结果无法解析', content: xhr.responseText },
                                status: xhr.status,
                            });
                        }
                    } else {
                        try {
                            const result = new Function(`return ${xhr.responseText}`)();

                            if (typeof result === 'object') {
                                reject(result);
                            } else {
                                reject({
                                    code: 'typeError',
                                    tips: '服务器忙，请稍后再试',
                                    msg: { msg: '返回结果不是对象', content: xhr.responseText },
                                    status: xhr.status,
                                });
                            }
                        } catch (e) {
                            reject({
                                code: 'parseError',
                                tips: '服务器忙，请稍后再试',
                                msg: { msg: '返回结果无法解析', content: xhr.responseText },
                                status: xhr.status,
                            });
                        }
                    }
                }
            };
            xhr.send(type.toLocaleLowerCase() === 'get' ? null : JSON.stringify(body));
        }),
        new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({
                    code: 'timeout',
                    tips: '服务器忙，请稍后再试',
                    msg: { msg: '请求超时', content: timeout },
                });
            }, timeout);
        }),
    ]);
}
